// Должен соответствовать projectName
/* istanbul ignore next */
export const UNIQUE_CONFIG_KEY = 'add-form-frontend';
export const USE_CHECK_SERVICE = true;
export const IS_AUTOPROLONG_DISABLED = false;
